import React from 'react';
import clsx from 'clsx';
import StyledElement from '@repo/checkout/components/StyledElement';

export default function FieldDescription({ field, className }) {
  const description = field?.description?.trim();

  if (!description) return null;

  return (
    <StyledElement
      elementPath="checkout.form.fields.description"
      as="p"
      id={`${field._id}_description`}
      className={clsx(
        'cp_form-description break-words',
        'text-[var(--cp_checkout-form-fields-description-color)]',
        '[padding-top:var(--cp_checkout-form-fields-description-padding-top)]',
        '[font-family:var(--cp_checkout-form-fields-description-font-family)]',
        '[font-style:var(--cp_checkout-form-fields-description-font-style)]',
        '[font-size:var(--cp_checkout-form-fields-description-font-size)]',
        '[line-height:var(--cp_checkout-form-fields-description-line-height)]',
        '[font-weight:var(--cp_checkout-form-fields-description-font-weight)]',
        className,
      )}
    >
      {description}
    </StyledElement>
  );
}
